import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/store/user.ts';
import { useCompanyAutopilotStore } from '@/store/useCompanyAutopilotStore.ts';

export const AUTOPILOT_ONLY_TICKETS_TOOLTIP = 'Questions are available only for Autopilot clients';
export const CHECKING_TICKETS_ACCESS_TOOLTIP = 'Checking Autopilot access...';
export const NO_TICKETS_ACCESS_TOOLTIP = 'No access rights';

/**
 * Access rules for questions (tickets):
 * accountants always manage them, managers — only for autopilot clients.
 */
export const useTicketsPermissions = () => {
  const { isAccountantRole, isManagerRole } = storeToRefs(useUserStore());
  const { isAutopilotClient, isLoading: isLoadingCompanyAutopilotData } = storeToRefs(useCompanyAutopilotStore());

  const canManageTickets = computed<boolean>(() => {
    return isAccountantRole.value || (isManagerRole.value && isAutopilotClient.value);
  });

  // Managers keep seeing the controls (disabled with a hint), other roles do not see them at all
  const isTicketControlHidden = computed<boolean>(() => !canManageTickets.value && !isManagerRole.value);

  const ticketAccessTooltip = computed<string>(() => {
    if (canManageTickets.value) return '';
    if (!isManagerRole.value) return NO_TICKETS_ACCESS_TOOLTIP;
    return isLoadingCompanyAutopilotData.value ? CHECKING_TICKETS_ACCESS_TOOLTIP : AUTOPILOT_ONLY_TICKETS_TOOLTIP;
  });

  return {
    isAccountantRole,
    isManagerRole,
    canManageTickets,
    isTicketControlHidden,
    ticketAccessTooltip,
  };
};
